import { CAR_TYPES } from 'site-modules/shared/constants/upper-funnel/car-types';

export const LEASE_DEALS_SUPPORTED_CAR_TYPES = [
  CAR_TYPES.SUV,
  CAR_TYPES.TRUCK,
  CAR_TYPES.SEDAN,
  CAR_TYPES.MINIVAN,
  CAR_TYPES.CONVERTIBLE,
  CAR_TYPES.CROSSOVER,
  CAR_TYPES.HATCHBACK,
  CAR_TYPES.COUPE,
  CAR_TYPES.WAGON,
  CAR_TYPES.ELECTRIC,
  CAR_TYPES.HYBRID,
];
